import { deepmerge } from '@utils/deepmerge';

export const buildChartJsOptionsProp = (options) => {
  return deepmerge({
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      datalabels: false,
      legend: { position: 'bottom' },
    },
    interaction: {
      axis: 'y',
      intersect: false,
      mode: 'nearest'
    },
    r: {
      angleLines: {
        display: false
      }
    }

  }, options);
}
